import React from "react";
import { currencyFormat, handleLocalize } from "../../utils/helper";
import {
  defaultLabelColors,
  getStatusColors,
  status_translations,
} from "../../utils/constants";
import moment from "moment";
import { Divider, Grid, IconButton } from "@mui/material";
import { HomeIcon, PointerIcon } from "../../assets/images/FrankIcons";
import { useMediaQuery, useTheme } from "@mui/system";
import { Squircle } from "corner-smoothing";
import PropTypes from 'prop-types';

interface AnnouncementCardProps  {
  i: any; // Replace `any` with the actual type if available
};


export default function AnnouncementCard({ i }: AnnouncementCardProps) {
    const theme = useTheme();
const screen_1024 = useMediaQuery(theme.breakpoints.up(1025));
const screen_600 = useMediaQuery(theme.breakpoints.up(601));
  return (
                                     <Squircle
                                       cornerRadius={24}
                                       cornerSmoothing={0.6}
                                       preserveSmoothing={true}
                                    //    onClick={() => handleGetJobInfo(i)}
                                       style={{
                                         background: defaultLabelColors?.white,
                                         padding: 20,
                                         cursor: "pointer",
                                       }}
                                     >
                                       <div
                                         style={{
                                           display: "flex",
                                           justifyContent: "space-between",
                                         }}
                                       >
                                         {i?.shipment_items?.length > 1 ? (
                                           <div style={{ width: "70%" }}>
                                             <h3
                                               style={{
                                                 color: "#080626",
                                                 fontFamily: "montserrat-Bold",
                                                 fontSize: screen_1024 ? 18 : "16px",
                                                 marginLeft: 1,
                                                 display: "-webkit-box",
                                                 WebkitLineClamp: 1, // Ensures the text is limited to one line
                                                 lineClamp: 1, // Fallback for browsers that support it
                                                 WebkitBoxOrient: "vertical",
                                                 maxWidth: "100%",
                                                 overflow: "hidden",
                                                 textOverflow: "ellipsis",
                                                 margin: 0,
                                               }}
                                             >
                                               {i?.shipment_items?.length ?? 1} articles :
                                               <span
                                                 style={{
                                                   color: "#78778A",
                                                   fontFamily: "montserrat-Regular",
                                                   fontSize: 12,
                                                   marginLeft: 1,
                                                 }}
                                               >
                                                 {" "}
                                                 {i?.shipment_items
                                                   ?.map((item: any) => item.item_name_fr)
                                                   .join(", ")}
                                               </span>
                                             </h3>
                                           </div>
                                         ) : (
                                           <h3
                                             style={{
                                               margin: 0,
                                               color: "#080626",
                                               fontFamily: "montserrat-Bold",
             
                                               fontSize: screen_1024 ? 18 : "16px",
             
                                               marginLeft: 1,
                                               display: "-webkit-box",
                                               WebkitLineClamp: 1, // Ensures the text is limited to one line
                                               lineClamp: 1, // Fallback for browsers that support it
                                               WebkitBoxOrient: "vertical",
                                               maxWidth: "63%",
                                               overflow: "hidden",
                                               textOverflow: "ellipsis",
                                             }}
                                           >
                                             {handleLocalize({
                                               fr: i?.shipment_items[0]?.item_name_fr,
                                               en: i?.shipment_items[0]?.item_name_en,
                                             }) ??
                                               i?.shipment_items[0]?.prod_name ??
                                               ""}{" "}
                                           </h3>
                                         )}
                                         <p
                                           style={{
                                             margin: 0,
                                             color: defaultLabelColors?.main_orange_new,
                                             fontSize: 18,
                                             fontFamily: "montserrat-Bold",
                                           }}
                                         >{`${currencyFormat(i?.ship_price)} €`}</p>
                                       </div>
                                       <div>
                                         <p
                                           style={{
                                             // margin: 0,
                                             // marginBottom: 4,
                                             color: "#78778A",
                                             fontSize: 12,
                                             fontFamily: "montserrat-Regular",
                                           }}
                                         >
                                           {`Publié le ${
                                             i?.created_at
                                               ? moment(i.created_at).format(
                                                   "DD/MM/YYYY à HH[h]mm"
                                                 )
                                               : ""
                                           }`}
                                         </p>
                                       </div>
                                       <div
                                         id="detail-div"
                                         style={{ display: "flex", gap: 10 }}
                                       >
                                         <div
                                           id="img-div"
                                           style={{
                                             display: !screen_1024 ? "none" : "block",
                                             width: "30%",
                                           }}
                                         >
                                           <Grid
                                             container
                                             spacing={0}
                                             sx={{
                                               height: "182px",
                                               // width: 'calc(100% - 100px)',
                                               maxWidth: "244px",
                                               // marginRight: "16px",
                                               // overflow:"hidden"
                                             }}
                                           >
                                             <Grid
                                               item
                                               xs={12}
                                               key={"_123"}
                                               sx={{
                                                 position: "relative",
                                                 backgroundImage: `url("${encodeURI(
                                                   i?.shipment_items?.[0]?.prod_images?.[0]
                                                 )}")`,
                                                 backgroundRepeat: "no-repeat",
                                                 backgroundPosition: "center",
                                                 backgroundSize: "cover",
                                                 borderRadius: "16px",
                                               }}
                                             ></Grid>
                                           </Grid>
                                         </div>
             
                                         <Squircle
                                           cornerRadius={16}
                                           cornerSmoothing={0.6}
                                           preserveSmoothing={true}
                                           className="card-details"
                                           style={{
                                             display: "flex",
                                             flexDirection: "row",
                                             background: "#F4F3F6",
                                             borderRadius: 16,
                                             padding: "16px 16px",
                                             gap: 10,
                                             cursor: "pointer",
                                             width: "70%",
                                           }}
                                         >
                                           <div
                                             style={{
                                               display: "flex",
                                               flexDirection: "column",
                                               justifyContent: "space-around",
                                             }}
                                           >
                                             <div
                                               style={{
                                                 width: "36px",
                                                 height: "36px",
                                                 borderRadius: "50%",
                                                 background: "#FFFFFF",
                                                 display: "flex",
                                                 alignItems: "center",
                                                 justifyContent: "center",
                                               }}
                                             >
                                               <HomeIcon height={30} color="#3026F1" />
                                             </div>
             
                                             {/* Dashed Line */}
                                             <div
                                               style={{
                                                 width: "2px",
                                                 height: "65px",
                                                 borderLeft: "2px dashed #BCBBC4",
                                                 margin: "auto",
                                               }}
                                             />
                                             <div
                                               style={{
                                                 width: "36px",
                                                 height: "36px",
                                                 borderRadius: "50%",
                                                 background: "#FFFFFF",
                                                 display: "flex",
                                                 alignItems: "center",
                                                 justifyContent: "center",
                                               }}
                                             >
                                               <PointerIcon height={30} color="#F15A24" />
                                             </div>
                                           </div>
                                           <div
                                             id="address-div"
                                             style={{
                                               display: "flex",
                                               // gap: 15,
                                               justifyContent: "space-between",
                                               flexDirection: "column",
                                               width: "100%",
                                             }}
                                           >
                                             <div
                                               id="yess"
                                               style={{
                                                 display: "flex",
                                                 justifyContent: "space-between",
                                               }}
                                             >
                                               <div>
                                                 <div
                                                   style={{
                                                     color: "#0000000",
                                                     fontSize: 14,
                                                     fontFamily: "montserrat-Regular",
                                                   }}
                                                 >
                                                   Adresse de ramassage
                                                 </div>
                                                 <div
                                                   style={{
                                                     color: "#0000000",
                                                     fontSize: screen_1024 ? 18 : 16,
                                                     fontFamily: "montserrat-Medium",
                                                   }}
                                                 >{`${i?.pickup?.city??"N/A"} , ${
                                                   i?.pickup?.country ?? "N/A"
                                                 }  ${
                                                   i?.pickup?.digital_code
                                                     ? `(${i?.pickup?.digital_code})`
                                                     : ""
                                                 } `}</div>
                                               </div>
                                             </div>
                                             <div>
                                               <div
                                                 style={{
                                                   color: "#0000000",
                                                   fontSize: 14,
                                                   fontFamily: "montserrat-Regular",
                                                 }}
                                               >
                                                 Adresse de livraison
                                               </div>
                                               <div
                                                 style={{
                                                   color: "#0000000",
                                                   // fontSize: 18,
                                                   fontSize: screen_1024 ? 18 : 16,
             
                                                   fontFamily: "montserrat-Medium",
                                                 }}
                                               >
                                                 {`${i?.dropoff?.city ?? "N/A"} , ${
                                                   i?.dropoff?.country ?? "N/A"
                                                 }  
                                                 ${
                                                   i?.dropoff?.digital_code
                                                     ? `(${i?.dropoff?.digital_code})`
                                                     : ""
                                                 }`}
                                               </div>
                                             </div>
                                           </div>
                                         </Squircle>
                                       </div>
                                     </Squircle>
  );
}
AnnouncementCard.prototype={
  i: PropTypes.string,

}
